module.exports = new Promise(resolve => {
          let remoteUrl = "/mfs/protection-insights/remoteEntry.js"
          if (false){
            remoteUrl = "http://localhost:4210/remoteEntry.js"
          }
          const script = document.createElement('script')
          script.src = remoteUrl
          script.onload = () => {
            const proxy = {
              get: (request) => window.protection_insights.get(request),
              init: (arg) => {
                try {
                  return window.protection_insights.init(arg)
                } catch(e) {
                  console.log('remote container already initialized')
                }
              }
            }
            resolve(proxy)
          }
          script.onerror = (error) => {
            console.error('Error loading protection_insights remote container', error);
            const proxy = {
              get: () => {
                return Promise.resolve(() => ({
                  __esModule: true,
                  mount: () => ({ unmount: () => {}, root: undefined }),
                  REMOTE_NAVIGATION_EVENT_KEY: "protection-insights:navigated",
                  HOST_NAVIGATION_EVENT_KEY: "protection-insights-host:navigated",
                  REMOTE_INVALIDATE_HOST_QUERY_KEY: "protection-insights-mf:invalidate-host-query",
                  HOST_INVALIDATE_REMOTE_QUERY_KEY: "protection-insights-host:invalidate-remote-query",
                  default: () => null,
                }));
              },
              init: () => {
                return;
              }
            }
            resolve(proxy)
          }
          document.head.appendChild(script);
        })
        ;